/**
 * Up and down one place in a list.
 *
 * Arrows rather than drag and drop: these lists are short, they are edited from
 * a phone as often as from a desk, and dragging a row on a touchscreen fights
 * with scrolling the page.
 *
 * `onMove(index, direction)` gets -1 for up and +1 for down. What that means —
 * saved straight away, or held until the page is saved — is the caller's
 * business; this only says which way.
 */
export default function MoveButtons({ index, count, onMove, disabled = false }) {
    const style = 'px-1 text-gray-500 hover:text-rdi-blue disabled:opacity-25 disabled:hover:text-gray-500 leading-none'

    return (
        <span className="whitespace-nowrap">
            <button
                type="button"
                className={style}
                onClick={() => onMove(index, -1)}
                disabled={disabled || index <= 0}
                title="Move up"
                aria-label="Move up"
            >
                ▲
            </button>
            <button
                type="button"
                className={style}
                onClick={() => onMove(index, 1)}
                disabled={disabled || index >= count - 1}
                title="Move down"
                aria-label="Move down"
            >
                ▼
            </button>
        </span>
    )
}
